import React from 'react';
import styled from '@xstyled/styled-components';
import QuestionSequenceIcon from '~/assets/icons/question-sequence.svg';
import TextSequenceIcon from '~/assets/icons/text-sequence.svg';
import TextCombinedSequenceIcon from '~/assets/icons/textcombined-sequence.svg';
import VideoSvgIcon from '~/assets/icons/video-sequence.svg';

const VideoIcon = styled(VideoSvgIcon)`
  margin-left: 2px;
`;

export const SequenceIcon = ({ icon }: { icon: string | undefined }) => {
  switch (icon) {
    case 'TextCombinedSequence':
      return <TextCombinedSequenceIcon />;
    case 'text':
      return <TextSequenceIcon />;
    case 'question':
      return <QuestionSequenceIcon />;
    case 'video':
      return <VideoIcon />;
  }
  return null;
};
